// Smooth scroll to a section by id without polluting the URL with a hash.
// Used by all internal anchor navigation so Chrome can't accidentally
// scroll back to a previously visited hash when a button/menu is clicked.
export function scrollToId(id) {
  return (e) => {
    if (!id) return;
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    // Defensive: also clear any leftover hash so future focus events don't snap back
    if (window.history?.replaceState && window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  };
}
